import { Injectable } from '@angular/core'

@Injectable()
export class MutationObserverFactory {

  public create(callback: MutationCallback) {
    return new MutationObserver(callback)
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/mutation-observer-factory.ts